import { List, Popper } from '@mui/material'
import CopyToClipboard from 'Components/_common/CopyToClipboard'

import { ActionsPopperItem } from './ActionsPopperItem'

export const ActionsPopper = ({
  anchorEl,
  actions,
  popperId = 'menu',
  placement = 'bottom',
  open,
  minWidth,
  zIndex = 2,
}) => (
  <Popper
    id={popperId}
    anchorEl={anchorEl}
    open={open}
    placement={placement}
    disablePortal
    sx={(theme) => ({
      background: theme.palette.background.paper,
      borderRadius: '8px',
      zIndex: zIndex,
      boxShadow: '0px 16px 64px -20px rgba(0, 0, 0, 0.4)',
      minWidth: minWidth,
    })}
  >
    <List>
      {actions?.map((menuItem, index) =>
        menuItem?.showItem ? (
          menuItem.isCopyCovered ? (
            <CopyToClipboard
              text={menuItem.link ?? window.location.href}
              key={index}
            >
              <ActionsPopperItem
                icon={menuItem.icon}
                isExpand={menuItem.isExpand}
                onClick={menuItem.onClick}
                title={menuItem.title}
                chipTitle={menuItem.chipTitle}
                color={menuItem.color}
                iconColor={menuItem.iconColor}
                isChecked={menuItem.isChecked}
              />
            </CopyToClipboard>
          ) : (
            <ActionsPopperItem
              key={index}
              icon={menuItem.icon}
              isExpand={menuItem.isExpand}
              onClick={menuItem.onClick}
              title={menuItem.title}
              chipTitle={menuItem.chipTitle}
              iconColor={menuItem.iconColor}
              color={menuItem.color}
              isChecked={menuItem.isChecked}
            />
          )
        ) : null,
      )}
    </List>
  </Popper>
)
